import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconConsoleSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconConsoleSparkle"><Path fillRule="evenodd" clipRule="evenodd" d="M21 15.6084L20.5596 15.4395L19.4307 12.5H16.5693L15.4395 15.4395L12.5 16.5693V19.4307L15.4395 20.5596L15.6084 21H3V3H21V15.6084ZM5.68945 6.75L7.43945 8.5L5.68945 10.25L6.75 11.3105L9.56055 8.5L6.75 5.68945L5.68945 6.75ZM10 11H13.5V9.5H10V11Z" fill="currentColor"/><Path d="M18.4 14H17.6L16.6 16.6L14 17.6V18.4L16.6 19.4L17.6 22H18.4L19.4 19.4L22 18.4V17.6L19.4 16.6L18.4 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconConsoleSparkle;
